import React, { FC, useEffect, useState } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import Contact from '../../../../../../../interfaces/api/Contact';
import useContact from '../../../../../../../hooks/api/useContact';
import { BsEyeFill as ViewIcon } from '@react-icons/all-files/bs/BsEyeFill';
import { Link } from 'react-router-dom';
import { createUseStyles } from '../../../../../../../theming';

interface Props {
  contactId: string;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
  },
});

const ContactField: FC<Props> = ({ contactId }) => {
  const [contact, setContact] = useState<Contact>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const classes = useStyles();

  const { get: getContact } = useContact();

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    getContact(contactId)
      .then((contact) => {
        setContact(contact);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [contactId]);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <div className={classes.root}>
      <TextField
        variant='outlined'
        label='Contact référent'
        defaultValue={`${contact?.firstname} ${contact?.lastname}`}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton component={Link} to={`/dashboard/crm/contacts/${contactId}`}>
              <ViewIcon color='#0000008a' />
            </IconButton>
          ),
        }}
        fullWidth
      />
    </div>
  );
};

export default React.memo(ContactField);
